import React from 'react';
import { useSpinradContext } from '../../context/SpinradContext';
import LockedSection from '../../lockedSection';
import Stepper from '../../stepper';
import StarRating from '../starRating';
import ValueChips from '../valueChips';
import {
  CreateTodoBtn,
  DeleteBtn,
  FinishBtn,
  NumBadge,
  SidebarWb,
  WbNav,
  WbNavArrow,
  WbNavLabel,
  WbNavName,
  WbNavPos,
  WbStepBox,
  WbStepHeading,
} from './styles';

const SidebarWbView: React.FC = () => {
  const {
    currentStep,
    activeWB,
    activeCard,
    wbList,
    openWorkboard,
    toggleCardValue,
    setCardRating,
    handleFinishWorkboard,
    handleDeleteWorkboard,
    openTodoCreate,
  } = useSpinradContext();

  const list = wbList();
  const idx = list.findIndex(c => c.id === activeWB);
  const prevDisabled = idx < 0 || idx >= list.length - 1;
  const nextDisabled = idx <= 0;
  const navPos = idx >= 0 ? `${list.length - idx}/${list.length}` : '–';

  const notes = activeCard
    ? activeCard.notes.filter(n => (n.text || '').trim())
    : [];
  const step3Locked = !activeCard || notes.length === 0;
  const step4Locked = !activeCard || (activeCard.values || []).length === 0;
  const allDone =
    !!activeCard &&
    (activeCard.values || []).length > 0 &&
    activeCard.rating > 0;

  return (
    <SidebarWb>
      <Stepper currentStep={currentStep} variant="wb" />

      <WbNav>
        <WbNavArrow
          type="button"
          title="Älteres Workboard"
          disabled={prevDisabled}
          onClick={() => {
            if (idx >= 0 && idx < list.length - 1)
              openWorkboard(list[idx + 1].id);
          }}
        >
          ‹
        </WbNavArrow>
        <WbNavLabel>
          <WbNavName>Workboard navigieren</WbNavName>
          <WbNavPos>{navPos}</WbNavPos>
        </WbNavLabel>
        <WbNavArrow
          type="button"
          title="Neueres Workboard"
          disabled={nextDisabled}
          onClick={() => {
            if (idx > 0) openWorkboard(list[idx - 1].id);
          }}
        >
          ›
        </WbNavArrow>
      </WbNav>

      <LockedSection locked={step3Locked}>
        <WbStepBox>
          <WbStepHeading>
            <NumBadge>3</NumBadge>Kernwerte zuordnen
          </WbStepHeading>
          <ValueChips
            selected={activeCard?.values || []}
            onToggle={name =>
              activeCard && toggleCardValue(activeCard.id, name)
            }
          />
        </WbStepBox>
      </LockedSection>

      <LockedSection locked={step4Locked}>
        <WbStepBox>
          <WbStepHeading>
            <NumBadge>4</NumBadge>Bewerten
          </WbStepHeading>
          <StarRating
            rating={activeCard?.rating || 0}
            onSetRating={n => activeCard && setCardRating(activeCard.id, n)}
          />
        </WbStepBox>
      </LockedSection>

      <FinishBtn
        type="button"
        disabled={!allDone}
        onClick={handleFinishWorkboard}
      >
        {activeCard?.finalized
          ? 'Aktualisieren & zur Übersicht'
          : 'Abschließen & zur Übersicht'}
      </FinishBtn>
      <DeleteBtn type="button" onClick={handleDeleteWorkboard}>
        Workboard löschen
      </DeleteBtn>
      <LockedSection locked={!allDone}>
        <CreateTodoBtn
          type="button"
          disabled={!allDone}
          onClick={openTodoCreate}
        >
          To-do erstellen
        </CreateTodoBtn>
      </LockedSection>
    </SidebarWb>
  );
};

export default SidebarWbView;
